<template>
  <div class="pagination-bar__container">
    <div
      v-if="isSummaryMode"
      class="text-muted small align-self-center"
    >
      Showing {{ rangeFrom }} to {{ rangeTo }} of {{ totalCount }} results{{ summarySuffix }}
    </div>
    <div v-else>
      <SelectInput
        v-model="selectedSize"
        :options="paginationSizeOptions"
        selectClass="form-select-sm"
        style="width: 70px"
        @change="onPaginationSizeChanged"
      />
    </div>
    <div
      v-if="!isSummaryMode || totalPages > 1"
      class="pagination__wrapper"
    >
      <ul class="pagination pagination-sm mb-0">
        <li :class="{ 'page-item': true, disabled: activePage === 1 }">
          <button
            aria-disabled="true"
            class="page-link"
            tabindex="-1"
            :disabled="isSummaryMode && activePage === 1"
            @click="onPaginationPageChanged(activePage - 1)"
          >
            Previous
          </button>
        </li>
      </ul>
      <ul class="pagination pagination-sm mb-0 pagination__scrollbar">
        <li
          v-for="pageNumber in visiblePages"
          :ref="`item-${pageNumber}`"
          :key="pageNumber"
          :class="{ 'page-item': true, active: pageNumber === activePage }"
        >
          <button
            class="page-link"
            @click="onPaginationPageChanged(pageNumber)"
          >
            {{ pageNumber }}
          </button>
        </li>
      </ul>
      <ul class="pagination pagination-sm mb-0">
        <li :class="{ 'page-item': true, disabled: activePage === totalPages }">
          <button
            class="page-link"
            :disabled="isSummaryMode && activePage === totalPages"
            @click="onPaginationPageChanged(activePage + 1)"
          >
            Next
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import SelectInput from '@/components/common/SelectInput';

const DEFAULT_WINDOW_SIZE = 5;

export default {
  components: {
    SelectInput,
  },
  props: [ 'totalPages', 'initialSelectedSize', 'page', 'totalCount', 'pageSize', 'windowSize', 'summarySuffix' ],
  emits: ['paginationChanged'],
  data() {
    const sizing = [ 10, 20, 50, 100 ];
    return {
      sizing,
      selectedSize: this.initialSelectedSize || sizing[0],
      currentPage: 1,
    };
  },
  computed: {
    paginationSizeOptions() {
      return _.map(this.sizing, (s) => ({ key: s, value: s }));
    },
    isSummaryMode() {
      return this.totalCount !== undefined && this.totalCount !== null;
    },
    activePage() {
      return this.isSummaryMode ? this.page : this.currentPage;
    },
    rangeFrom() {
      return this.totalCount ? (this.page - 1) * this.pageSize + 1 : 0;
    },
    rangeTo() {
      return Math.min(this.page * this.pageSize, this.totalCount);
    },
    visiblePages() {
      const totalPages = Number(this.totalPages) || 0;
      if (!this.isSummaryMode) {
        return _.range(1, totalPages + 1);
      }
      const size = Math.min(this.windowSize || DEFAULT_WINDOW_SIZE, totalPages);
      const start = Math.max(1, Math.min(this.page - Math.floor(size / 2), totalPages - size + 1));
      return _.range(start, start + size);
    },
  },
  methods: {
    onPaginationSizeChanged() {
      this.currentPage = 1;
      this.$emit('paginationChanged', this.buildPaginationEventData());
    },
    onPaginationPageChanged(pageNumber) {
      if (this.isSummaryMode) {
        if (pageNumber >= 1 && pageNumber <= this.totalPages && pageNumber !== this.page) {
          this.$emit('paginationChanged', { selectedSize: this.pageSize, currentPage: pageNumber });
        }
        return;
      }
      this.currentPage = pageNumber;
      this.$emit('paginationChanged', this.buildPaginationEventData());
    },
    buildPaginationEventData() {
      return {
        selectedSize: this.selectedSize,
        currentPage: this.currentPage,
      };
    },
  },
};
</script>
<style>
.pagination-bar__container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pagination__wrapper {
  display: flex;
  flex-direction: row;
}
.pagination__scrollbar {
  max-width: 500px;
  overflow: hidden;
  overflow-x: auto;
}

.pagination__scrollbar::-webkit-scrollbar {
  height: 10px;
}

.pagination__scrollbar::-webkit-scrollbar-track {
  background: #f5f5f5;
}

.pagination__scrollbar::-webkit-scrollbar-thumb {
  background: #e1e1e1;
}
</style>
